const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve(position); // location access granted
                },
                (error) => {
                    let errorMessage = "";
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            errorMessage = "This website does not have permission to use the location.";
                            break;
                        case error.POSITION_UNAVAILABLE:
                            errorMessage = "The current position is unavailable.";
                            break;
                        case error.TIMEOUT:
                            errorMessage = "The current position could not be determined within the specified timeout period. Try again.";
                            break;
                        default:
                            errorMessage = `Error getting location: ${error.message}`;
                            break;
                    }
                    reject(errorMessage)
                },
                {
                    enableHighAccuracy: true,
                    timeout: 60000,
                    maximumAge: -1
                }
            );
        } else {
            reject('Geolocation is not available in your browser.');
        }
    });
};

export const mutateWithLocation = async (mutationFunction, payload) => {
    try {
        const position = await getCurrentLocation();
        const coords = position.coords;
        payload.Location = {
            Latitude: coords?.latitude ?? 0,
            Longitude: coords?.longitude ?? 0
        };
        await mutationFunction(payload);
    } catch (error) {
        console.error("Error in mutateWithLocation:", error); // Debugging
        throw error;
    }
};


export const nowTimePretty = () => new Date().toLocaleString("de-GE");